import React, { useState, useEffect } from 'react';
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import DashboardCharts from '../../Components/Admin/DashboardCharts/DashboardCharts'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import TiendaInfoCard from '../../Components/Admin/TiendaInfoCard/TiendaInfoCard'
import { fetchUsuario, getUsuario } from '../../Components/user';
import ServiciosData from '../../Components/Admin/ServiciosData/ServiciosData'
export default function Main() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />

                {loading ? (
                    < ></>
                ) : usuarioLegued?.idUsuario ? (
                    <>
                        {usuarioLegued?.rol === 'admin' ? (
                            <>
                               <div className='containerMain'>
                            <div className='deFLexMain'>
                                <CardsCantidad />
                                <TiendaInfoCard />
                            </div>
                            <DashboardCharts />
                      <div className='container2'>
                                  <ServiciosData />
                            </div>
                        </div>
                            </>
                        ) : usuarioLegued?.rol === 'colaborador' ? (
                            <>
                                <div className='container2'>
                                    <ServiciosData />
                                </div>

                            </>
                        ) : (
                            <div>

                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className='containerMain'>
                            <div className='deFLexMain'>
                                <CardsCantidad />
                                <TiendaInfoCard />
                            </div>
                            <DashboardCharts />
                      <div className='container2'>
                                  <ServiciosData />
                            </div>
                        </div>
                    </>
                )}
                <div>

                </div>
            </section>
        </div>
    )
}
